import { push, replace } from 'connected-react-router';
import { actionCreators as Notification } from './Notification';
import restHttp from '../../utils/restHttp';

const requestListType = 'loyality/couponCampaign/list/request';
const receiveListType = 'loyality/couponCampaign/list/receive';
const requestGetType = 'loyality/couponCampaign/get/request';
const receiveGetType = 'loyality/couponCampaign/get/receive';
const requestCouponTypesType = 'loyality/couponCampaign/couponTypes/request';
const receiveCouponTypesType = 'loyality/couponCampaign/couponTypes/receive';
const requestPostType = 'loyality/couponCampaign/post/request';
const receivePostType = 'loyality/couponCampaign/post/receive';
const requestPutType = 'loyality/couponCampaign/put/request';
const receivePutType = 'loyality/couponCampaign/put/receive';
const requestDeleteType = 'loyality/couponCampaign/delete/request';
const receiveDeleteType = 'loyality/couponCampaign/delete/receive';
const requestStopType = 'loyality/couponCampaign/stop/request';
const receiveStopType = 'loyality/couponCampaign/stop/receive';
const switchDisplayStyle = 'loyality/couponCampaign/display';
const requestParseType = 'loyality/couponCampaign/parse/request';
const receiveParseType = 'loyality/couponCampaign/parse/receive';
const requestRecipientsType = 'loyality/couponCampaign/recipients/request';
const receiveRecipientsType = 'loyality/couponCampaign/recipients/receive';
const clearParseType = 'loyality/couponCampaign/parse/clear';

const initialState = {
  list: [],
  paging: { sortBy: 'createdOn', sortDescending: true, pageSize: 40 },
  filters: [],
  preferTable: true,
  couponTypes: [],
  recipients: [],
};

export const actionCreators = {
  requestList: (pageIndex, pageSize, sortBy, sortDescending, filters) => (dispatch) => {
    dispatch({ type: requestListType });

    restHttp
      .get('couponCampaign', restHttp.pageOptions(pageIndex, pageSize, sortBy, sortDescending, filters))
      .then((response) => {
        dispatch({
          type: receiveListType,
          list: response.data,
          paging: restHttp.pagingHeader(response),
          filters,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestGet: id => (dispatch) => {
    dispatch({ type: requestGetType });

    restHttp
      .get(`couponCampaign/${id}`)
      .then((response) => {
        dispatch({
          type: receiveGetType,
          current: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestCouponTypes: couponCampaignId => (dispatch) => {
    dispatch({ type: requestCouponTypesType });

    restHttp
      .get(`couponCampaign/couponTypes?couponCampaignId=${couponCampaignId || ''}`)
      .then((response) => {
        dispatch({
          type: receiveCouponTypesType,
          couponTypes: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPost: (entity, publish) => (dispatch) => {
    dispatch({ type: requestPostType });

    restHttp
      .post(`couponCampaign?publish=${publish}`, entity)
      .then((response) => {
        dispatch({
          type: receivePostType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Kuponu Izsūtīšana izveidota!'));
        dispatch(replace('/coupon-campaign'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestPut: (id, entity, publish) => (dispatch) => {
    dispatch({ type: requestPutType });

    restHttp
      .put(`couponCampaign/${id}?publish=${publish}`, entity)
      .then((response) => {
        dispatch({
          type: receivePutType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Kuponu Izsūtīšana atjaunota!'));
        // dispatch(push('/couponCampaign'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestDelete: id => (dispatch) => {
    dispatch({ type: requestDeleteType });

    restHttp
      .delete(`couponCampaign/${id}`)
      .then(() => {
        dispatch({
          type: receiveDeleteType,
        });
        dispatch(Notification.addSuccess('Kuponu Izsūtīšana izdzēsta!'));
        dispatch(push('/coupon-campaign'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestStop: id => (dispatch) => {
    dispatch({ type: requestStopType });

    restHttp
      .put(`couponCampaign/${id}/stop`)
      .then((response) => {
        dispatch({
          type: receiveStopType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Kuponu Izsūtīšana apturēta!'));
        // dispatch(push('/couponCampaign'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  requestContinue: id => (dispatch) => {
    dispatch({ type: requestStopType });

    restHttp
      .put(`couponCampaign/${id}/continue`)
      .then((response) => {
        dispatch({
          type: receiveStopType,
          current: response.data,
        });
        dispatch(Notification.addSuccess('Kuponu Izsūtīšana atsākta!'));
        // dispatch(push('/couponCampaign'));
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  switchDisplayStyle: () => (dispatch) => {
    dispatch({ type: switchDisplayStyle });
  },
  requestParse: file => (dispatch) => {
    dispatch({ type: requestParseType });

    const data = new FormData();
    data.append('file', file);

    restHttp
      .post('couponCampaign/parse', data)
      .then((response) => {
        dispatch({
          type: receiveParseType,
          recipients: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  clearParse: () => (dispatch) => {
    dispatch({ type: clearParseType, recipients: [] });
  },
  requestRecipients: () => (dispatch) => {
    dispatch({ type: requestRecipientsType });

    restHttp
      .get('couponCampaign/recipients')
      .then((response) => {
        dispatch({
          type: receiveRecipientsType,
          recipients: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
};

export const reducer = (state, action) => {
  const newState = state || initialState;

  if (action.type === receiveListType) {
    return {
      ...newState,
      list: action.list,
      paging: action.paging,
      filters: action.filters,
    };
  }

  if (action.type === receiveGetType || action.type === receivePostType || action.type === receivePutType || action.type === receiveStopType) {
    return {
      ...newState,
      current: action.current,
    };
  }

  if (action.type === switchDisplayStyle) {
    return {
      ...newState,
      preferTable: !state.preferTable,
    };
  }

  if (action.type === receiveCouponTypesType) {
    return {
      ...newState,
      couponTypes: action.couponTypes,
    };
  }

  if (action.type === receiveParseType || action.type === clearParseType || action.type === receiveRecipientsType) {
    return {
      ...newState,
      recipients: action.recipients,
    };
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/store/modules/CouponCampaign.js